import React from 'react';
import Link from '../Link/Link';

const FeaturedEntity = ({ entity: entity }) => {
  if (!entity) return null;

  const { name, number_of_items, image, banner_image, url } = entity;
  const editionsString = number_of_items === 1 ? 'edition' : 'editions';

  // Determine if we should use the banner image and specific styling
  const useBannerImage = !!banner_image;
  const displayedImage = useBannerImage ? banner_image : image;

  // Conditionally construct the className for the card
  // Add 'featured-card--entity-banner' only when banner_image is used
  const cardClassName = `featured-card featured-card--entity ${
    useBannerImage ? 'featured-card--entity-banner' : ''
  }`.trim(); // .trim() removes trailing space if banner class isn't added

  return (
    <Link fullUrl={url} className="featured-card-link">
      <div className={cardClassName}>
        <div className="featured-card__image-container">
          {displayedImage ? (
            <img src={displayedImage} alt={name} />
          ) : (
            // Placeholder will be styled differently based on parent class via SCSS
            <div className="featured-card__no-image-placeholder"></div>
          )}
        </div>
        <h3 className="featured-card__title">{name}</h3>
        <p className="featured-card__detail">{number_of_items} {editionsString}</p>
      </div>
    </Link>
  );
};

export default FeaturedEntity;
